// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"daa8ebba","265":"4520937b","668":"90c7cefb"}[chunkId] + ".chunk.js";
};